import { DeleteClassificationMutation, DeleteClassificationMutationVariables } from 'app/__generated__/global';
import { ApolloProvider } from 'core/net/ApolloProvider';
import Guid from 'core/types/Guid';
import { DELETE_CLASSIFICATION } from './graphql/facility.deleteClassification';

export const deleteNoiseEventClassification = async (id: Guid): Promise<boolean> => {
  const { data, error } = await ApolloProvider.global().mutate<
    DeleteClassificationMutation,
    DeleteClassificationMutationVariables
  >({
    mutation: DELETE_CLASSIFICATION,
    variables: {
      id,
    },
  });
  if (!data || error) throw new Error(error?.message);
  return data.facility.classification.deleteClassification ?? false;
};
